import {
  getLeoUuid,
  LeoUUID,
  getString,
} from "@surya-digital/leo-ts-types";

export interface APIKeyManagementProjectDTO {
  projectId: string;
  projectName: string;
}

export class APIKeyManagementProject {
  readonly isAPIKeyManagementProjectAPIKeyManagementProject: boolean = true;

  readonly projectId: LeoUUID;
  readonly projectName: string;


  constructor(
  projectId: LeoUUID, 
  projectName: string
  ) {
    this.projectId = projectId;
    APIKeyManagementProject.validateProjectName(projectName);
    this.projectName = projectName;
  }

  static fromDTO(dto: APIKeyManagementProjectDTO): APIKeyManagementProject {
    const projectId = getLeoUuid(dto, "projectId", InvalidAPIKeyManagementProjectProjectIdError);
    const projectName = getString(dto, "projectName", InvalidAPIKeyManagementProjectProjectNameError);
    return new APIKeyManagementProject(
      projectId,
      projectName
    );
  }

  toDTO(): APIKeyManagementProjectDTO {
    const dto: APIKeyManagementProjectDTO = {
        projectId: this.projectId.toDTO(),
        projectName: this.projectName
    };
    return dto;
  }
  private static validateProjectName = (projectName: string): void => {
    if(projectName.trim().length === 0) {
      throw new InvalidAPIKeyManagementProjectProjectNameNonEmptyError(
        `Attribute projectName cannot be an empty string.`
      );
    }
  }
  
}

APIKeyManagementProject.prototype.toString = function toString(): string {
  return `APIKeyManagementProject(projectId='${this.projectId}',projectName='${this.projectName}')`;
};

export class InvalidAPIKeyManagementProjectError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAPIKeyManagementProjectError";
  }
}
export class InvalidAPIKeyManagementProjectProjectIdError extends InvalidAPIKeyManagementProjectError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAPIKeyManagementProjectProjectIdError";
  }
}

export class InvalidAPIKeyManagementProjectProjectNameError extends InvalidAPIKeyManagementProjectError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAPIKeyManagementProjectProjectNameError";
  }
}

export class InvalidAPIKeyManagementProjectProjectNameNonEmptyError extends InvalidAPIKeyManagementProjectProjectNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAPIKeyManagementProjectProjectNameNonEmptyError";
  }
}
